import Grid from '@mui/material/Unstable_Grid2';
import { ReactNode } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInput, FormInputProps } from '../../../../components/form/FormInput';
import { FormSwitch } from '../../../../components/form/FormSwitch';

type Props = {
  inputProps: Partial<FormInputProps>;
  control: Control<any>;
  slot?: ReactNode;
  readonly?: boolean;
};

export const VendorFormPart = ({ inputProps, slot, control, readonly }: Props) => {
  const { t } = useTranslation();

  return (
    <Grid container py={2} px={0} spacing={2} mt={1}>
      <Grid xs={12} md={6}>
        <FormInput
          {...inputProps}
          readonly={readonly}
          control={control}
          name={'vendor.vatId'}
          label={t('vatId') + ' *'}
        />
      </Grid>
      {slot ? (
        <Grid xs={12} md={6}>
          {slot}
        </Grid>
      ) : null}
      <Grid xs={12} md={12}>
        <FormInput {...inputProps} readonly={readonly} control={control} name={'vendor.taxId'} label={t('taxId')} />
      </Grid>
      <Grid xs={12}>
        <FormInput
          {...inputProps}
          readonly={readonly}
          control={control}
          name={'vendor.name'}
          label={t('businessName') + '*'}
        />
      </Grid>
      <Grid xs={12}>
        <FormInput
          {...inputProps}
          readonly={readonly}
          multiline={true}
          minRows={3}
          control={control}
          name={'vendor.address'}
          label={t('streetAddress')}
        />
      </Grid>
    </Grid>
  );
};
